import { Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import { useWorkspaceSwitching } from "src/context/WorkspaceSwitchingContext";
import TravelSidebar from "src/components/travel/shared/TravelSidebar";
import TravelHeader from "src/components/travel/shared/TravelHeader";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";
import { classNames } from "src/helpers/classNames";
import TravelFooter from "src/components/travel/shared/TravelFooter";

const TravelLayout2 = () => {
  const { finishSwitching } = useWorkspaceSwitching();
  const [menuOpen, setMenuOpen] = useState(true);

  useEffect(() => {
    finishSwitching();
  }, [finishSwitching]);

  return (
    <div className="flex min-h-screen bg-gradient-to-bl from-[#744773] via-[#572f5f] to-[#744773] font-lato font-normal">
      <div className={classNames("fixed bottom-0 left-0 top-0 flex w-96 flex-shrink-0 transition-all duration-300", menuOpen ? "" : "-translate-x-full")}>
        <TravelSidebar />
      </div>
      <div className={classNames("flex flex-shrink flex-grow flex-col transition-all duration-300", menuOpen ? "ml-96" : "")}>
        <TravelHeader />
        <div className={classNames("relative flex w-full flex-shrink flex-grow transition-all duration-300")}>
          <div className={classNames("relative w-full overflow-hidden bg-gradient-to-b from-[#f5f0fd] to-[#e3dffd] shadow-[-2px_-2px_10px_rgba(0,0,0,0.2)]", menuOpen ? "rounded-l-3xl" : "")}>
            <div className="max-h-[calc(100dvh-7rem)] overflow-auto">
              <Outlet />
            </div>
          </div>
          <button
            type="button"
            onClick={() => setMenuOpen(!menuOpen)}
            className={classNames("absolute bottom-6 flex aspect-square w-7 items-center justify-center rounded-l-3xl transition-all duration-300", menuOpen ? "-translate-x-full bg-[#e3dffd] text-[#572f5f]" : "translate-x-0 rotate-180 bg-[#744773] text-white")}>
            <ChevronLeftIcon className="h-4 w-4 stroke-2" />
          </button>
        </div>
        <TravelFooter />
      </div>
    </div>
  );
};

export default TravelLayout2;
